import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';

export interface UpdateInternalConfigPayload {
  name?: string;
  status?: 'CURRENT' | 'INACTIVE';
  includeInMasterList?: boolean;
  hasValidity?: boolean;
  validityDate?: string | null;
  format?: string;
  editedByUserId?: number;
  editedByPositionId?: number;
  configuredAt?: string;
  physicalLocations?: { locationId: number; quantity: number }[];
  notificationDates?: string[];
  notificationMemberIds?: number[];
}

class UpdateInternalConfigApi {
  async updateInternalConfig(
    revisionId: number,
    data: UpdateInternalConfigPayload
  ): Promise<ApiResponse<unknown>> {
    const response = await api.patch<ApiResponse<unknown>>(
      `/document-revisions/${revisionId}/internal-config`,
      data
    );
    return response.data;
  }
}

export default new UpdateInternalConfigApi();
